import { useQuery } from '@tanstack/react-query';
import { useCustomersApi } from './use-customers-api';

const QK_GET_SALES_AGENTS_GROUPS = () => ['sales-agents', 'groups'] as const;

export function useSalesAgentsGroups(enabled?: boolean) {
  const { customersApi } = useCustomersApi();

  return useQuery({
    queryKey: QK_GET_SALES_AGENTS_GROUPS(),
    queryFn: () => customersApi.salesAgentGroups(),
    enabled: enabled,
  });
}
